;(function(){
  // Immediately restore scroll position if needed (runs before everything else)
  // This prevents any scrolling animation by using ID to directly position
  (function restoreScrollEarly() {
    try {
      // Check URL hash first
      var hash = window.location.hash;
      var formId = null;
      
      // Check sessionStorage
      var savedPosition = sessionStorage.getItem('mt-footer-form-scroll');
      if (savedPosition) {
        var position = JSON.parse(savedPosition);
        if (Date.now() - position.timestamp < 10000) {
          formId = position.formId;
        }
      }
      
      // Use hash if available
      if (hash && hash.startsWith('#')) {
        formId = hash.substring(1);
      }
      
      if (formId && document.getElementById) {
        var form = document.getElementById(formId);
        if (form) {
          // Disable smooth scrolling immediately
          if (document.documentElement) {
            document.documentElement.style.scrollBehavior = 'auto';
          }
          if (document.body) {
            document.body.style.scrollBehavior = 'auto';
          }
          
          // Try scrollIntoView with instant behavior
          try {
            form.scrollIntoView({ behavior: 'instant', block: 'start' });
          } catch (e) {
            try {
              form.scrollIntoView({ behavior: 'auto', block: 'start' });
            } catch (e2) {
              // Fallback: direct scrollTop
              var formRect = form.getBoundingClientRect();
              var formTop = formRect.top + window.pageYOffset;
              if (document.documentElement) {
                document.documentElement.scrollTop = formTop;
              }
              if (document.body) {
                document.body.scrollTop = formTop;
              }
              if (window.scrollTo) {
                window.scrollTo(0, formTop);
              }
            }
          }
        }
      }
    } catch (e) {
      // Ignore errors in early execution
    }
  })();
  
  function createPanelFromSiblings(titleEl) {
    var panel = document.createElement('div');
    panel.className = 'mt-footer__panel';
    var nodesToMove = [];
    var n = titleEl.nextElementSibling;
    while (n) { nodesToMove.push(n); n = n.nextElementSibling; }
    nodesToMove.forEach(function(node){ panel.appendChild(node); });
    titleEl.insertAdjacentElement('afterend', panel);
    return panel;
  }

  function attachToggle(titleEl, panel, isOpenDefault) {
    // add icon if not exists
    if (!titleEl.querySelector('.mt-footer__toggle-icon')) {
      var icon = document.createElement('span');
      icon.className = 'mt-footer__toggle-icon';
      icon.setAttribute('aria-hidden', 'true');
      icon.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      titleEl.appendChild(icon);
    }

    function setOpen(open) {
      if (open) {
        panel.classList.add('is-open');
        titleEl.classList.add('is-open');
      } else {
        panel.classList.remove('is-open');
        titleEl.classList.remove('is-open');
      }
    }

    setOpen(!!isOpenDefault);

    titleEl.addEventListener('click', function(){
      var root = titleEl.closest('.mt-footer');
      if (!root) return;
      // close others within same column group
      var column = titleEl.closest('.mt-footer__left, .mt-footer__right') || root;
      column.querySelectorAll('.mt-footer__panel').forEach(function(p){ if (p !== panel) p.classList.remove('is-open'); });
      column.querySelectorAll('.mt-footer__title').forEach(function(t){ if (t !== titleEl) t.classList.remove('is-open'); });
      // toggle this
      var open = !panel.classList.contains('is-open');
      setOpen(open);
    });
  }

  function initContainer(container) {
    var firstOpenDone = false;
    container.querySelectorAll('.mt-footer__block').forEach(function(block){
      // only within blocks that contain at least one footer menu
      if (!block.querySelector('.mt-footer__menu')) return;

      var titles = Array.from(block.querySelectorAll('.mt-footer__title'));
      titles.forEach(function(titleEl){
        // verify this title has a menu between it and the next title (or block end)
        var hasMenuFollowing = false;
        var nextTitle = titleEl.nextElementSibling;
        while (nextTitle && !nextTitle.classList.contains('mt-footer__title')) {
          if (nextTitle.classList && nextTitle.classList.contains('mt-footer__menu')) { hasMenuFollowing = true; break; }
          nextTitle = nextTitle.nextElementSibling;
        }
        if (!hasMenuFollowing) return;

        var panel = titleEl.nextElementSibling && titleEl.nextElementSibling.classList.contains('mt-footer__panel')
          ? titleEl.nextElementSibling
          : (function(){
              // collect siblings until the next title to form this panel
              var panelEl = document.createElement('div');
              panelEl.className = 'mt-footer__panel';
              var n = titleEl.nextElementSibling;
              var siblings = [];
              while (n && !n.classList.contains('mt-footer__title')) { siblings.push(n); n = n.nextElementSibling; }
              siblings.forEach(function(node){ panelEl.appendChild(node); });
              titleEl.insertAdjacentElement('afterend', panelEl);
              return panelEl;
            })();

        titleEl.classList.add('has-toggle');
        attachToggle(titleEl, panel, !firstOpenDone);
        firstOpenDone = true;
      });
    });
  }

  function initMobileAccordions(){
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    var roots = document.querySelectorAll('.mt-footer');
    if (!roots.length) return;
    roots.forEach(function(root){
      var left = root.querySelector('.mt-footer__left');
      var right = root.querySelector('.mt-footer__right');
      if (left) initContainer(left);
      if (right) initContainer(right);
    });
  }

  document.addEventListener('DOMContentLoaded', initMobileAccordions);

  // Newsletter form AJAX submission
  function initNewsletterForms() {
    var forms = document.querySelectorAll('.mt-footer form[id^="mt-footer-newsletter-"]');
    forms.forEach(function(form) {
      form.addEventListener('submit', function submitHandler(e) {
        var formEl = e.target;
        if (!formEl || !(formEl instanceof HTMLFormElement)) return;
        
        // Store the submit handler for potential removal
        var handler = submitHandler;
        
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        
        // Get form position for direct jump (no scrolling animation)
        var formRect = formEl.getBoundingClientRect();
        var formTop = formRect.top + window.pageYOffset;
        
        // Function to directly jump to form position (instant, no animation)
        var jumpToForm = function() {
          // Disable smooth scrolling temporarily
          var htmlStyle = document.documentElement.style;
          var bodyStyle = document.body.style;
          var originalScrollBehavior = htmlStyle.scrollBehavior;
          htmlStyle.scrollBehavior = 'auto';
          bodyStyle.scrollBehavior = 'auto';
          
          // Set scroll position directly (instant, no animation)
          document.documentElement.scrollTop = formTop;
          document.body.scrollTop = formTop;
          window.scrollTo(0, formTop);
          
          // Restore original scroll behavior
          htmlStyle.scrollBehavior = originalScrollBehavior;
          bodyStyle.scrollBehavior = originalScrollBehavior;
        };
        
        var submitButton = formEl.querySelector('button[type="submit"]');
        var input = formEl.querySelector('.mt-footer__newsletter-input');
        var statusContainer = formEl.parentElement;
        if (!statusContainer) return;
        
        // Remove existing status messages
        var existingStatus = statusContainer.querySelector('.mt-footer__newsletter-status, [role="status"], [role="alert"]');
        if (existingStatus) {
          existingStatus.remove();
        }
        
        // Disable submit button
        if (submitButton && submitButton instanceof HTMLButtonElement) {
          submitButton.disabled = true;
        }
        
        // Build FormData with required fields for Shopify customer form
        var formData = new FormData(formEl);
        
        // Ensure form_type is set (required for Shopify customer forms)
        if (!formData.has('form_type')) {
          formData.append('form_type', 'customer');
        }
        
        // Ensure contact[email] exists
        var emailValue = formData.get('contact[email]');
        if (!emailValue && input && input instanceof HTMLInputElement) {
          emailValue = input.value;
          if (emailValue) {
            formData.set('contact[email]', emailValue);
          }
        }
        
        // Ensure contact[tags] exists
        if (!formData.has('contact[tags]')) {
          formData.append('contact[tags]', 'newsletter');
        }
        
        // Get form action URL (use form's action attribute if available)
        var formAction = formEl.getAttribute('action') || '/contact';
        
        // Check for CAPTCHA token - Shopify may require it
        var captchaInput = formEl.querySelector('input[name="h-captcha-response"]');
        var captchaToken = captchaInput ? captchaInput.value : null;
        
        // Try to get CAPTCHA token from hCaptcha widget if available
        if (!captchaToken && typeof window.hcaptcha !== 'undefined') {
          try {
            // Try to find widget by looking for hCaptcha iframe or container
            var captchaContainer = formEl.querySelector('.h-captcha, [data-hcaptcha-widget-id], [id*="hcaptcha"]');
            if (captchaContainer) {
              // Try to get widget ID from various possible attributes
              var widgetId = captchaContainer.getAttribute('data-hcaptcha-widget-id') ||
                           captchaContainer.getAttribute('id') ||
                           captchaContainer.getAttribute('data-widget-id');
              
              if (widgetId) {
                // Remove any non-numeric characters to get the actual widget ID
                var numericId = widgetId.replace(/\D/g, '');
                if (numericId) {
                  captchaToken = window.hcaptcha.getResponse(numericId);
                } else {
                  captchaToken = window.hcaptcha.getResponse(widgetId);
                }
              }
            }
            
            // If still no token, try to find all hCaptcha widgets and get the first one
            if (!captchaToken) {
              try {
                // hCaptcha stores widgets in an internal object, try to access it
                if (window.hcaptcha && typeof window.hcaptcha.getResponse === 'function') {
                  // Try common widget IDs (0, 1, etc.)
                  for (var i = 0; i < 10; i++) {
                    try {
                      var testToken = window.hcaptcha.getResponse(i);
                      if (testToken && testToken.length > 0) {
                        captchaToken = testToken;
                        break;
                      }
                    } catch (e) {
                      // Continue trying
                    }
                  }
                }
              } catch (e) {
                // Ignore errors
              }
            }
          } catch (e) {
            console.warn('Could not get CAPTCHA token:', e);
          }
        }
        
        // Also check for reCAPTCHA (grecaptcha)
        if (!captchaToken && typeof window.grecaptcha !== 'undefined') {
          try {
            var recaptchaContainer = formEl.querySelector('[data-sitekey], .g-recaptcha');
            if (recaptchaContainer) {
              var siteKey = recaptchaContainer.getAttribute('data-sitekey');
              if (siteKey) {
                // reCAPTCHA v2
                var recaptchaWidgetId = recaptchaContainer.getAttribute('data-widget-id');
                if (recaptchaWidgetId) {
                  captchaToken = window.grecaptcha.getResponse(recaptchaWidgetId);
                }
              } else {
                // reCAPTCHA v3 - execute and get token
                if (typeof window.grecaptcha.execute === 'function') {
                  var recaptchaSiteKey = document.querySelector('script[src*="recaptcha"]');
                  if (recaptchaSiteKey) {
                    // Extract site key from script src or use a default
                    window.grecaptcha.ready(function() {
                      window.grecaptcha.execute(siteKey || '', {action: 'submit'}).then(function(token) {
                        captchaToken = token;
                      });
                    });
                  }
                }
              }
            }
          } catch (e) {
            console.warn('Could not get reCAPTCHA token:', e);
          }
        }
        
        // Add CAPTCHA token if available
        if (captchaToken) {
          formData.append('h-captcha-response', captchaToken);
        } else {
          // Check if CAPTCHA might be required by Shopify
          // If no token and server requires it, we'll handle the error response
          // Don't add empty CAPTCHA field
          if (captchaInput && !captchaInput.value) {
            formData.delete('h-captcha-response');
          }
        }
        
        // Submit form via AJAX
        fetch(formAction, {
          method: 'POST',
          body: formData,
          redirect: 'manual'
        })
        .then(function(response) {
          // Check if response is ok
          if (!response.ok && response.status !== 200) {
            // Try to get error message from response
            return response.text().then(function(html) {
              // Check if error is due to missing CAPTCHA
              if (html.includes('Missing CAPTCHA token') || html.includes('CAPTCHA')) {
                // If CAPTCHA is required, fall back to normal form submission
                // This allows Shopify's built-in CAPTCHA handling to work
                if (submitButton && submitButton instanceof HTMLButtonElement) {
                  submitButton.disabled = false;
                }
                
                // Get form ID for direct positioning
                var formId = formEl.getAttribute('id') || 'newsletter-form';
                
                // Save form ID to sessionStorage before submitting
                // This will be used after page reload to restore scroll position
                try {
                  var formPosition = {
                    formId: formId,
                    timestamp: Date.now()
                  };
                  sessionStorage.setItem('mt-footer-form-scroll', JSON.stringify(formPosition));
                } catch (e) {
                  console.warn('Could not save scroll position:', e);
                }
                
                // Add hash to current URL so browser can jump directly to form
                // This prevents scrolling animation
                try {
                  var currentUrl = window.location.href.split('#')[0];
                  window.location.hash = formId;
                } catch (e) {
                  // Ignore if can't set hash
                }
                
                // Remove this event listener and allow normal form submission
                formEl.removeEventListener('submit', handler);
                
                // Create a new submit event and dispatch it (this will trigger normal submission)
                var submitEvent = new Event('submit', { bubbles: true, cancelable: true });
                formEl.dispatchEvent(submitEvent);
                
                // If event wasn't prevented by something else, submit normally
                if (!submitEvent.defaultPrevented) {
                  formEl.submit();
                }
                
                throw new Error('CAPTCHA_REQUIRED');
              }
              throw new Error('Server returned ' + response.status + ': ' + html.substring(0, 200));
            });
          }
          return response.text();
        })
        .then(function(html) {
          // Check for redirect or refresh in response
          if (html.includes('location.reload') || html.includes('meta http-equiv="refresh"')) {
            // Remove scripts that might cause refresh
            html = html.replace(/<script[^>]*>[\s\S]*?location\.reload[\s\S]*?<\/script>/gi, '');
            html = html.replace(/<meta[^>]*http-equiv=["']refresh["'][^>]*>/gi, '');
          }
          
          // Parse the response to check for success
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var successMessage = doc.querySelector('.mt-footer__newsletter-status') || 
                              doc.querySelector('[role="status"]') ||
                              (html.includes('posted_successfully') ? { textContent: 'Thanks for subscribing!' } : null);
          
          if (successMessage) {
            // Show success message after the form
            var statusEl = document.createElement('p');
            statusEl.className = 'mt-footer__newsletter-status';
            statusEl.setAttribute('role', 'status');
            statusEl.textContent = successMessage.textContent || 'Thanks for subscribing!';
            
            // Prevent the new element from causing scroll
            statusEl.style.scrollMargin = '0';
            statusEl.style.scrollPadding = '0';
            statusEl.style.scrollBehavior = 'auto';
            
            // Insert after the form (at the bottom of the newsletter block)
            if (formEl.nextSibling) {
              statusContainer.insertBefore(statusEl, formEl.nextSibling);
            } else {
              statusContainer.appendChild(statusEl);
            }
            
            // Recalculate form position after DOM insertion and jump instantly
            requestAnimationFrame(function() {
              formRect = formEl.getBoundingClientRect();
              formTop = formRect.top + window.pageYOffset;
              jumpToForm();
              
              // Ensure position is maintained
              requestAnimationFrame(function() {
                jumpToForm();
                setTimeout(function() {
                  jumpToForm();
                }, 0);
              });
            });
            
            // Clear input (but don't focus it to prevent scroll)
            if (input && input instanceof HTMLInputElement) {
              input.value = '';
              input.blur(); // Remove focus to prevent any scroll
            }
            
            // Fade out and remove status message after 3 seconds
            setTimeout(function() {
              if (statusEl) {
                statusEl.classList.add('is-fading');
                setTimeout(function() {
                  if (statusEl && statusEl.parentNode) {
                    statusEl.parentNode.removeChild(statusEl);
                    // Maintain position after removing element
                    jumpToForm();
                  }
                }, 400);
              }
            }, 3000);
          } else {
            // Check for errors
            var errorMessage = doc.querySelector('[role="alert"]') || 
                              doc.querySelector('.error') ||
                              doc.querySelector('.form__message--error');
            
            var errorText = 'An error occurred. Please try again.';
            if (errorMessage) {
              errorText = errorMessage.textContent || errorText;
            } else {
              // Check if response indicates an error
              if (html.includes('error') || html.includes('invalid') || html.includes('required')) {
                errorText = 'Please check your email and try again.';
              }
            }
            
            var errorEl = document.createElement('p');
            errorEl.setAttribute('role', 'alert');
            errorEl.textContent = errorText;
            errorEl.style.scrollMargin = '0';
            errorEl.style.scrollPadding = '0';
            errorEl.style.scrollBehavior = 'auto';
          
            if (formEl.nextSibling) {
              statusContainer.insertBefore(errorEl, formEl.nextSibling);
            } else {
              statusContainer.appendChild(errorEl);
            }
            
            // Jump to form position immediately
            requestAnimationFrame(function() {
              formRect = formEl.getBoundingClientRect();
              formTop = formRect.top + window.pageYOffset;
              jumpToForm();
            });
          }
        })
        .catch(function(error) {
          // If CAPTCHA is required, the form will be submitted normally
          // Don't show error for CAPTCHA requirement
          if (error.message && error.message.includes('CAPTCHA_REQUIRED')) {
            return; // Exit silently, form is being submitted normally
          }
          
          console.error('Newsletter subscription error:', error);
          var errorEl = document.createElement('p');
          errorEl.setAttribute('role', 'alert');
          
          // Check if error message mentions CAPTCHA
          if (error.message && error.message.includes('CAPTCHA')) {
            errorEl.textContent = 'Please complete the CAPTCHA verification and try again.';
          } else {
            errorEl.textContent = 'An error occurred. Please try again.';
          }
          
          errorEl.style.scrollMargin = '0';
          errorEl.style.scrollPadding = '0';
          errorEl.style.scrollBehavior = 'auto';
          
          if (formEl && formEl.nextSibling) {
            statusContainer.insertBefore(errorEl, formEl.nextSibling);
          } else if (statusContainer) {
            statusContainer.appendChild(errorEl);
          }
            
          // Jump to form position immediately
          if (formEl) {
            requestAnimationFrame(function() {
              formRect = formEl.getBoundingClientRect();
              formTop = formRect.top + window.pageYOffset;
              jumpToForm();
            });
          }
        })
        .finally(function() {
          // Re-enable submit button
          if (submitButton && submitButton instanceof HTMLButtonElement) {
            submitButton.disabled = false;
          }
          
          // Ensure we're at the form position (instant jump, no animation)
          requestAnimationFrame(function() {
            formRect = formEl.getBoundingClientRect();
            formTop = formRect.top + window.pageYOffset;
            jumpToForm();
            requestAnimationFrame(function() {
              jumpToForm();
            });
          });
        });
      });
    });
  }

  // Restore scroll position immediately using ID (for CAPTCHA fallback)
  // This function uses element ID to directly position, preventing scroll animation
  function restoreFormScrollPosition() {
    try {
      // First check URL hash
      var hash = window.location.hash;
      var formId = null;
      
      // Check sessionStorage for saved form ID
      var savedPosition = sessionStorage.getItem('mt-footer-form-scroll');
      if (savedPosition) {
        var position = JSON.parse(savedPosition);
        // Only restore if it was saved recently (within last 10 seconds)
        if (Date.now() - position.timestamp < 10000) {
          formId = position.formId;
        } else {
          // Clear old saved position
          sessionStorage.removeItem('mt-footer-form-scroll');
        }
      }
      
      // Use hash if available, otherwise use saved formId
      if (hash && hash.startsWith('#')) {
        formId = hash.substring(1);
      }
      
      if (formId) {
        // Immediately disable smooth scrolling globally
        var htmlStyle = document.documentElement.style;
        var bodyStyle = document.body.style;
        htmlStyle.scrollBehavior = 'auto';
        bodyStyle.scrollBehavior = 'auto';
        
        // Function to jump to form using ID directly
        var jumpToFormById = function() {
          var form = document.getElementById(formId);
          if (form) {
            // Use scrollIntoView with instant behavior (no animation)
            try {
              form.scrollIntoView({ behavior: 'instant', block: 'start' });
            } catch (e) {
              // Fallback for browsers that don't support 'instant'
              try {
                form.scrollIntoView({ behavior: 'auto', block: 'start' });
              } catch (e2) {
                // Final fallback: direct scrollTop setting
                var formRect = form.getBoundingClientRect();
                var formTop = formRect.top + window.pageYOffset;
                document.documentElement.scrollTop = formTop;
                document.body.scrollTop = formTop;
                window.scrollTo(0, formTop);
              }
            }
            
            // Also directly set scrollTop as backup
            var formRect = form.getBoundingClientRect();
            var formTop = formRect.top + window.pageYOffset;
            htmlStyle.scrollBehavior = 'auto';
            bodyStyle.scrollBehavior = 'auto';
            document.documentElement.scrollTop = formTop;
            document.body.scrollTop = formTop;
            window.scrollTo(0, formTop);
          }
        };
        
        // Execute immediately
        jumpToFormById();
        
        // Execute as soon as possible in next frame
        if (window.requestAnimationFrame) {
          requestAnimationFrame(function() {
            jumpToFormById();
            requestAnimationFrame(function() {
              jumpToFormById();
            });
          });
        }
        
        // Also execute after tiny delays to catch any late scrolls
        setTimeout(jumpToFormById, 0);
        setTimeout(jumpToFormById, 10);
        setTimeout(jumpToFormById, 50);
        setTimeout(jumpToFormById, 100);
        
        // Clear the saved position after use
        if (savedPosition) {
          sessionStorage.removeItem('mt-footer-form-scroll');
        }
      }
    } catch (e) {
      console.warn('Could not restore scroll position:', e);
      try {
        sessionStorage.removeItem('mt-footer-form-scroll');
      } catch (e2) {
        // Ignore
      }
    }
  }
  
  // Execute immediately if script loads after DOM is ready
  if (document.readyState !== 'loading') {
    restoreFormScrollPosition();
  }
  
  // Also execute on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restoreFormScrollPosition, { once: true });
  }
  
  // Execute on window load as well
  window.addEventListener('load', function() {
    // Small delay to ensure everything is rendered
    setTimeout(restoreFormScrollPosition, 0);
  }, { once: true });

  // Initialize newsletter forms
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initNewsletterForms();
    });
  } else {
    initNewsletterForms();
  }

  // Re-initialize on section load (for theme editor)
  document.addEventListener('shopify:section:load', function(event) {
    initNewsletterForms();
  });
})();


